module.exports = __webpack_public_path__ + "static/media/image_30.624e2f53.png";